import cx from 'classnames'

import './Loader.scss'

const Loader = ({ className }) => (
    <div className={cx(`loader ${className}`)}>
        <div className="spinner orbit-star">
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
        </div>
    </div>
)

export default Loader
